import { isRequiredText, strMax } from '../../utils';
export default {
    other: [
        isRequiredText('その他を入力してください'),
        strMax(10, '10文字以内で入力してください'),
    ],
};
